import { NgModule, ModuleWithProviders, Injector } from "@angular/core";
import { CommonModule } from "@angular/common";
import {
  AppTranslationService,
  AccountService,
  LocalStoreManager,
  AuthGuard,
  HttpCommonService,
  AnalyticsService,
} from "projects/sepidz-web-framework/src/lib/services";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import {
  JuriNameValidator,
  HexadecimalValueValidator,
  ValidationComponent,
  DatePickerComponent,
  ButtonComponent,
  TextareaComponent,
  SepidzMenuComponent,
} from "../shared/controls";
import { TreeViewModule } from "@progress/kendo-angular-treeview";
import { FormControlModelComponent } from "./controls/form/form-control-model.component";
import { DynamicFormComponent } from "./controls/form/dynamic-form.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CorrectYeKeService } from "projects/sepidz-web-framework/src/lib/services";
import { NgSelectModule } from "./controls/ng-select/ng-select.module";
import { ErrorDialogModule } from "projects/sepidz-web-framework/src/lib/services/error-dialog/error-dialog.module";
import { LookupComponent } from "./controls/lookup/lookup.component";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { MinDirective, MaxDirective } from "./controls/base/min.max.directive";
import { GridModule, ExcelModule, PDFModule } from "@progress/kendo-angular-grid";
import { AlertService } from "projects/sepidz-web-framework/src/lib/services/alert.service";
import { LayoutService } from "projects/sepidz-web-framework/src/lib/@core/utils/layout.service";
import { LookupTreeComponent } from "./controls/lookup-tree/lookup-tree.component";
import { CacheInterceptor } from "projects/sepidz-web-framework/src/lib/interceptors/cache-interceptor";
import { DpDatePickerModule } from "projects/persian-date-picker/src/lib";
import { TranslateLanguageLoader } from "projects/sepidz-web-framework/src/lib/services/app-translation.service";
import { AuthInterceptor } from "projects/sepidz-web-framework/src/lib/interceptors/auth.interceptor";
import { SelectorComponent } from "./controls/selector/selector.component";
import { InputComponent } from "./controls/input/input.component";
import { SepCheckboxComponent } from "./controls/checkbox-new/checkbox.component";
import { RadioboxComponent } from "./controls/radiobox/radiobox.component";
import { TemplateInputComponent } from "./controls/template-input/template-input.component";
import { CheckboxListComponent } from "./controls/checkbox-list/checkbox-list.component";
import { TimePickerComponent } from "./controls/timepicker/time-picker.component";
import { ColorPickerModule } from "ngx-color-picker";
import { SepidzColorPickerComponent } from "./controls/sepidz-color-picker/sepidz-color-picker.component";
import { TagInputComponent } from "./controls/tag-input/tag-input.component";
import { PersianDatePipe } from "projects/sepidz-web-framework/src/lib/pipes/persian-date.pipe";
import { HasPermissionDirective } from "./directives/has-permission.directive";
import { SwichBoxComponent } from "./controls/swichbox/swichbox.component";
import { CurrencyMask } from "./controls/base/currency-mask.directive";
import { RequestCacheService } from "projects/sepidz-web-framework/src/lib/interceptors/request-cache.service";
import { PersianNumberPipe } from "projects/sepidz-web-framework/src/lib/pipes/persian-number.pipe";
import { InCellTabDirective } from "./directives/incell-tab.directive";
import { CanDeactivateGuard } from "projects/sepidz-web-framework/src/lib/can-deactivate/can-deactivate.guard";
import { FormDirective } from "./directives/focus-invalid-input.directive";
import { AutoFocusDirective } from "./directives/auto-focus.directive";
import { SplashFormModule } from "./splash-form/splash-form.module";
import { SsgTabsetModule } from "../tabular/tabset/tabset.module";
import { SimpleModalModule } from "projects/sepidz-web-framework/src/lib/services/sepidzmodal/simple-modal.module";
import { GroupByPipe } from "projects/sepidz-web-framework/src/lib/pipes/group-by.pipe";
import { ClickOutsideDirective } from "projects/sepidz-web-framework/src/lib/services/clickoutside.directive";
import { JwtHelper } from "projects/sepidz-web-framework/src/lib/services/jwt-helper";
import { MapObjectPipe } from "projects/sepidz-web-framework/src/lib/pipes/mapobject.pipe";
import { FilterPipe } from "projects/sepidz-web-framework/src/lib/pipes/filter.pipe";
import { TooltipModule, TooltipOptions } from "./controls/tooltip";
import { PersianService } from "../../../../sepidz-web-framework/src/lib/services/persian.service";
import { SSGDraggable } from "projects/sepidz-web-framework/src/lib/services/dragable.directive";
import { ContextMenuModule } from "./controls/rightclick/context-menu.module";

import { AngularResizeElementModule } from "./controls/resizable/angular-resize-element.module";
import { ErrorInterceptor } from "projects/sepidz-web-framework/src/lib/interceptors/http-error-response-interceptor";
import { EncryptDecryptAuthInterceptor } from "projects/sepidz-web-framework/src/lib/interceptors/encrypt-decrypt/encrypt-decrypt-interceptor";
import { ThousandSeparatorPipe } from "projects/sepidz-web-framework/src/lib/pipes/thousand-separator.pipe";
import { TranslateEnum } from "projects/sepidz-web-framework/src/lib/pipes/translate-enum.pipe";
import { SsgMaskDirective } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/SsgMaskDirective";
import { SSGPopOverComponent } from "./controls/popover/ssg-popover.component";
export let AppInjector: Injector;

export const MyDefaultTooltipOptions: TooltipOptions = {
  "show-delay": 500,
  autoPlacement: true,
};

const components = [
  DatePickerComponent,
  JuriNameValidator,
  HexadecimalValueValidator,
  ValidationComponent,
  FormControlModelComponent,
  DynamicFormComponent,
  LookupComponent,
  MinDirective,
  MaxDirective,
  CurrencyMask,
  LookupTreeComponent,
  ButtonComponent,
  PersianDatePipe,
  TranslateEnum,
  MapObjectPipe,
  SepidzColorPickerComponent,
  SelectorComponent,
  InputComponent,
  SepCheckboxComponent,
  RadioboxComponent,
  TemplateInputComponent,
  TextareaComponent,
  CheckboxListComponent,
  TimePickerComponent,
  TagInputComponent,
  HasPermissionDirective,
  InCellTabDirective,
  SwichBoxComponent,
  PersianNumberPipe,
  ThousandSeparatorPipe,
  FormDirective,
  AutoFocusDirective,
  GroupByPipe,
  FilterPipe,
  SepidzMenuComponent,
  ClickOutsideDirective,
  SSGDraggable,
  SsgMaskDirective,
  SSGPopOverComponent,
];
const providers = [
  AppTranslationService,
  AccountService,
  AuthGuard,
  LocalStoreManager,
  AlertService,
  CorrectYeKeService,
  HttpCommonService,
  LayoutService,
  AnalyticsService,
  RequestCacheService,
  JwtHelper,
];
@NgModule({
  declarations: [...components],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ErrorDialogModule,
    SplashFormModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: TranslateLanguageLoader,
      },
    }),
    NgSelectModule,
    DpDatePickerModule,
    GridModule,
    ExcelModule,
    PDFModule,
    HttpClientModule,
    TreeViewModule,
    ColorPickerModule,
    SsgTabsetModule,
    SimpleModalModule.forRoot({ container: document.body }),
    TooltipModule.forRoot(MyDefaultTooltipOptions as TooltipOptions),
    ContextMenuModule,
    AngularResizeElementModule,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ...components,
    TranslateModule,
    NgSelectModule,
    PersianDatePipe,
    TranslateEnum,
    MapObjectPipe,
    ColorPickerModule,
    DpDatePickerModule,
    SimpleModalModule,
    SsgTabsetModule,
    GroupByPipe,
    FilterPipe,
    TooltipModule,
    ContextMenuModule,
    AngularResizeElementModule,
  ],
  providers: [
    ...providers,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: CacheInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: EncryptDecryptAuthInterceptor, multi: true },
    PersianService,
  ],
})
export class SharedModule {
  constructor(private injector: Injector) {
    AppInjector = this.injector;
  }
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [...providers, CanDeactivateGuard],
    };
  }
}
